import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_APP_REGISTRATION || "your-azure-app-registration-client-id",  // Azure AD App Registration Client ID
    authority: "https://login.microsoftonline.com/" + (process.env.REACT_APP_AZURE_AD_TENANT || "your-azure-tenant-id"),
    redirectUri: process.env.REACT_APP_REDIRECT_URL || "http://localhost:3000"
  },
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["user.Read"] // Used only for MS Graph (user profile/email)
};

// Backend API scope — acquired silently after login using the same MSAL session.
// No client secret needed: this is the user-delegated PKCE flow.
export const backendRequest = {
  scopes: ['api://ingestion.pensieve/.default']
};

// NOTE: Automation Insights previously used a second, independently-scoped
// request here (`automationInsightsRequest`) to call the legacy standalone
// Automation Dashboard backend, which had its own Azure AD app registration.
// Retired 2026-08-25 — Automation Insights now talks to
// topsreliabilityframework-automationapi, this platform's own service, and
// authenticates with the normal sign-in token above (see services/authFetch.ts).
// No second scope, no second app registration, no admin-consent dependency.

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me", // e.g. https://graph.microsoft.com/v1.0/me
};